module.exports = __webpack_public_path__ + "static/sports-e6dbd1a5e45c3064714cd5082a8407a0.jpg";